export interface IMohCapitationBand {
  eqiLow: number;
  eqiHigh: number;
  title: string;
  fee: number;
  code: MohCapitationCode;
}

export type MohCapitationCode = 'COM1' | 'COM2' | 'COM3';

export const MOH_CAPITATION_BANDS: Record<
  MohCapitationCode,
  IMohCapitationBand
> = {
  COM1: {
    eqiHigh: 569,
    eqiLow: 491,
    title: 'Band 1 (EQI 491 – 569)',
    fee: 257.65,
    code: 'COM1',
  },
  COM2: {
    eqiHigh: 490,
    eqiLow: 448,
    title: 'Band 2 (EQI 448 – 490)',
    fee: 198.59,
    code: 'COM2',
  },
  COM3: {
    eqiHigh: 447,
    eqiLow: 365,
    title: 'Band 3 (EQI 365 – 447)',
    fee: 162.48,
    code: 'COM3',
  },
};

export enum MohSchoolException {
  SchoolNotListed = -1,
  NotEnrolled = -2,
}

export const DEFAULT_MOH_CAPITATION_BAND = MOH_CAPITATION_BANDS.COM3;
export const NOT_ENROLLED_MOH_CAPITATION_BAND = MOH_CAPITATION_BANDS.COM2;
